export const reviews = [
  {
    name: "Adelina C.",
    text: "Foarte mulțumită si incantata de aceasta clinică. Un prieten mi-a recomandat sa merg la ei si cu tot dragul o sa o recomand si mai departe la rândul meu. Clinica este foarte moderna si curata. Îmi era foarte frica sa merg , dar domnul doctor Alfred mi-a explicat in fiecare moment pasurile tratamentului. Ma gândeam ca poate o sa fie nevoie de anestezie, dar nu am simțit nici o durere sau disconfort. Atât el ,cât si restul personalului sunt foarte prietenoși, atenți la detalii si profesionali. Excelenta experiența. Recomand clinica ArtDent cu incredere",
    color: "orange",
  },
  {
    name: "Ovidiu B.",
    text: "Cautam un dentist aproape si cum trebuie sa tratez si sa previn niste carii. Am inceput cu un consult / radiografie / detartraj - absolut minunat! Dotari de calitate, foarte curat, un doctor tanar si mega priceput. Si daca... daca se intampla sa asteptati... puneti mana pe cartea asta de pe pervazul din dreapta ",
    color: "green",
  },
  {
    name: "Damian F.",
    text: "Recomand cu toată încrederea! Am avut mai multe probleme cu dantura, mai exact carii profunde, dinți rupți, măsele sparte și infecții. Am stabilit cu domnul doctor tratamentele și pașii pe care îi vom parcurge, iar după ce am terminat planul de tratament, pot spune că parcă nu mai sunt eu când mă uit în oglindă. Pot zâmbi iar și mi-am recăpătat încrederea în mine. Sunt foarte mulțumit de serviciile clinicii și voi reveni de fiecare dată pentru consultații.",
    color: "purple",
  },
  {
    name: "Isabella T.",
    text: "Foarte draguț la ei! M-am simțit bine primită, locație curată, personal amabil și domnul doctor primitor și înțelegător cu “emoțiile” pacienților trecuți prin experiențe nu tocmai plăcute 😄 Recomand cu drag!",
    color: "red",
  },
  {
    name: "Alexandru I.",
    text: "Profesionalism, talent și calitate. Clinica este foarte călduroasă și curată, personalul este atent, amabil și servicial iar doctorul Alfred Pițurlea un adevărat profesionist în domeniu, a lucrat excepțional. Recomand cu toată încrederea!",
    color: "black"
  },
  {
    name: "Elisa E.",
    text: "Recomand cu mare drag clinica ArtDent din Valea Lupului. Amabilitatea, profesionalismul și condițiile de 5 stele sunt lucruri normale. Și cel mai important m-am simțit în siguranță. Îți este explicat fiecare detaliu până înțelegi și colaborează cu doctori excelenți. Se pune binele omului pe primul loc iar asta este cel mai important. Succes mult în continuare!",
    color: "blue"
  },
  {
    name: "Lavinia C.",
    text: "Totul era foarte curat și dotat cu echipamente moderne. Atmosfera din interiorul cabinetelor este una primitoare! Dr. Alfred Piturlea este foarte amabil și profesionist! Recomand cu căldură acest cabinet!",
    color: "cyan"
  },
  {
    name: "Evelina I.",
    text: "Clinica ArtDent este sinonimul profesionalismului, avangardei, căldurii, curățeniei și nu numai. Recomand clinica ArtDent - Valea Lupului pentru orice tratament dentar. Clinica este extrem de moderna si curata, cu o atmosfera primitoare si un personal extraordinar.",
    color: "red"
  },
  {
    name: "Rebeca B.",
    text: "Revin cu un review dupa câteva luni bune de când mi s-a făcut un tratament endodontic la Clinica ArtDent. Nu am mai avut deloc dureri, s-a lucrat cu profesionalism, seriozitate și rapiditate, oferindu-mi-se detalii despre procedură pe parcurs. Cabinetul este foarte curat, un aspect foarte important pentru mine. Recomand 100% ✅",
    color: "orange"
  },
  {
    name: "Irina C.",
    text: "Recomand!!💙 Personalul tânăr, zâmbete largi de fiecare dată, o energie pozitivă transmisă la fiecare vizită și să nu uit de serviciile excelente. Prețurile sunt pe măsura serviciilor oferite și sincer nu sunt mari comparând cu alte clinici la care am mers. Revin cu drag de fiecare dată și nu doar la durere.😜😜 Multumesc mult pentru grijă și atenție ArtDent🦷🦷",
    color: "green"
  },
  {
    name: "Louis B.",
    text: "Am avut o experiență excelentă la clinica stomatologicã ArtDent. De la momentul în care am intrat, am fost întâmpinat cu un zâmbet cald de către personal. Atmosfera din sala de așteptare este plăcută și relaxantã. Instrumentarul și echipamentele sunt moderne și bine întreținute.Am fost impresionat de igiena din cabinet și de respectarea strictă a măsurilor de siguranță. De asemenea, prețurile sunt rezonabile pentru calitatea serviciilor oferite. Recomand cu încredere clinica ArtDent.",
    color: "purple"
  },
  {
    name: "Isabella T.",
    text: "Foarte draguț la ei! M-am simțit bine primită, locație curată, personal amabil și domnul doctor primitor și înțelegător cu “emoțiile” pacienților trecuți prin experiențe nu tocmai plăcute😄 Recomand cu drag!",
    color: "black"
  },
  {
    name: "Simona A.",
    text: "Am fost la începutul anului pentru o intervenție destul de complicata și totul a decurs peste așteptările mele. Un medic de excepție care tratează nevoile pacientului pe primul plan,la care cu siguranță voi reveni si il voi mai recomanda tuturor. 🤩🤩🦷💯",
    color: "blue"
  },
  {
    name: "Anaiss V.",
    text: "Recomand cu mare drag această clinică. Domnul doctor Alfred este foarte înțelegător, atent la detalii, iar primirea în clinică e una caldă și prietenoasă. Totul este modern și curat.",
    color: "cyan"
  },
  {
    name: "Teona R.",
    text: "O experiență profesională si foarte plăcută. Am apreciat enorm faptul că mi-a fost luată în considerare frica de intervenții și servicii dentare, doctorul stomatolog explicandu-mi pe parcurs tot ceea ce se întâmplă. Recomand cu toată încrederea!",
    color: "red"
  },
  {
    name: "Cristian D.",
    text: "Dl doctor este foarte atent la detalii si un OM deosebit. Am schimbat o plomba la dintii din fata, nu iti dai seama ca e plomba acolo nici cu lupa. Sunt extrem de multumit si ii recomand. Atmosfera din cabinet este foarte placuta, curatenie maxima, totul modern, muzica clasica.",
    color: "green"
  },
  {
    name: "Gabriel V.",
    text: "Servicii de calitate inalta, fara durere. O placere sa fii pacient aici! Mult succes si cat mai multi pacienti fericiti!🤗🙏",
    color: "purple"
  },
  {
    name: "Evelina B.",
    text: "Super multumita. Calitatea serviciilor 10+. Echipa super - atenția la recuperare si in fiecare etapa a tratamentului, echipamente, proceduri si tehnologii moderne, 0 dureri sau neplaceri",
    color: "black"
  },
];
